import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/HybridProducts';

export const HYBRID_PRODUCTS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const HYBRID_PRODUCTS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
